// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__OLmUZ","footer":"styles_footer__pD5ww","passCodeTooltip":"styles_passCodeTooltip__fiD5C"};